import { executeRequest, Request } from '@jfs/network'
import { AgentInfo } from '../../data/models/Agent'
import { RootStore } from '../../data/store'
import {
  generateRandomString,
  getCompleteDate,
  getNetworkResponseError,
  isStatusOK,
  RSAEncrypt,
  TRANSACTION_CONSTANTS,
} from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
import { COUNTRY_CODE } from './LoginReq'

export const SUCCESS_CODE = '00'

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const TRANSACTION_META_DATA = {
  type: 425,
  subType: 612,
  livemode: 'true',
  TYPE: 13,
}

const transferAmountBody = (body: any, agent: typeof AgentInfo.properties, idempotentKey: any) => {
  //Based on convenience fee response.
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)

  return {
    transaction: {
      idempotentKey, //Logic based
      currency: TRANSACTION_CONSTANTS.currency, //Default hard coded
      invoice: body?.invoiceNo,
      method: {
        type: TRANSACTION_META_DATA.type, //Need to get from BE
        subType: TRANSACTION_META_DATA.subType, //Need to get from BE
      },
      mode: TRANSACTION_CONSTANTS.mode,
      //Header of agent
      metadata: {
        agent: {
          address: {
            stateCode: agent.agentUserDealerState,
            pinCode: agent.agentUserDealerPinCode,
          },
          agentUser: {
            id: agent.agentUserLoginId,
          },
          id: '1000000001',
          organization: {
            id: '1',
          },
        },
        terminal: {
          id: null,
        },
      },
      captureMethod: TRANSACTION_CONSTANTS.captureMethod, //Hard coded
      livemode: TRANSACTION_META_DATA.livemode, //Hard coded
      application: RootStore?.agent?.session?.CHANNEL_ID, //AEPS channel ID
      initiatingEntityTimestamp: getCompleteDate(), //Current time stamp
      initiatingEntity: {
        entityId: RootStore?.agent?.session?.CHANNEL_ID, //HARDCODED AS PER DISCUSSED IN CALL
        callbackUrl: TRANSACTION_CONSTANTS.callbackUrl, //hard coded
      },
    },
    amount: {
      // example - user entered 10 Rs -> NetAmt = 10 Rs. GrossAmt = 15 // value = 5 // value from api response // service charge = 3
      netAmount: Number(body?.amountEnteredByUser), //Amount entered by user
      grossAmount: Number(body?.totalConvenienceFee) + Number(body?.amountEnteredByUser), //value from below + net amount
      //Convenience fee response
      charges: [body?.charges],
    },
    //Remitter Details <-> Payer
    payer: {
      userId: body?.remittanceUserId || RootStore?.customerDetails?.newRemittanceUserId, //Remitter id
      mobile: {
        number: body?.mobile, //remitter phone number
        countryCode: COUNTRY_CODE,
      },
      type: TRANSACTION_META_DATA.TYPE,
    },
    payee: {
      accountAlias: body?.beneficiaryId, //Beneficiary ID
    },
    secure: {
      encryptionKey: encryptedKey,
      deviceInfo: {
        peripheral: 'biometric device encrypted code',
        source: {
          type: 'MOB',
          id: RootStore?.agent?.deviceInfo?.id,
          ip: RootStore?.agent?.deviceInfo?.ip,
          osType: 'ANDROID',
          osVer: RootStore?.agent?.deviceInfo?.osVer,
          model: RootStore?.agent?.deviceInfo?.model,
        },
        location: {
          latitude: RootStore?.agent?.deviceInfo?.latitude,
          longitude: RootStore?.agent?.deviceInfo?.longitude,
        },
      },
    },
    auth: {
      consentCode: btoa(body?.otp),
    },
  }
}

export const transferAmount = (tokens: any, body: any, idempotentKey: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const request: Request<{}> = {
    apiPath: APIEndPoints.transferMoney,
    method: 'POST',
    config: config,
    body: transferAmountBody(body, RootStore.agent.agentInfo, idempotentKey),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })

  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
